import React, { useState } from "react";
import { Container, Modal, ModalBody } from "reactstrap";
import SelectCustomer from "../sections/saleOrderSections/SelectCustomer";

function CreateNewOrderModal({ toggle, modal }) {
  const [customer, setCustomer] = useState({});

  return (
    <div>
      <Modal
        isOpen={modal}
        toggle={toggle}
        centered
        size="xl"
        onClosed={() => {
          setCustomer({});
        }}
      >
        <ModalBody>
          <h3 className=" my-3">Create New Order</h3>
          <hr />
          <Container>
            <SelectCustomer
              customer={customer}
              setCustomer={setCustomer}
              toggle={toggle}
            />
          </Container>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default CreateNewOrderModal;
